export default __webpack_public_path__ + "static/media/medicasur-logo.dcdcc69c.png";